import { useEffect } from 'react';
import { THEME_TYPE, useStateStorage } from 'store/state';
import { IChildrenProp } from 'types/components/components.interface';

const ThemeProvider = ({ children }: IChildrenProp) => {
  const { theme, themeType } = useStateStorage();

  const defaultTheme = {
    id: 'default',
    name: 'Default',
    primary: '#4f90ff',
    text: '#162032',
    background: '#ffffff',
    appBackground: '#e3e6ea',
    secondarySoft: '#d8deea',
    secondaryLight: '#919bad',
    secondary: '#5b6575',
    darkPrimary: '#4f90ff',
    darkText: '#e4e4f2',
    darkBackground: '#0e151f',
    darkAppBackground: '#080b10',
    darkSecondarySoft: '#626a77',
    darkSecondaryLight: '#8b93a1',
    darkSecondary: '#647084',
    isPredefined: true,
    isActive: true,
  };

  const setPropertyColor = (property: string, light: string, dark: string) => {
    const color =
      themeType === null
        ? theme?.defaultThemeMode === THEME_TYPE.light
          ? light
          : dark
        : themeType === THEME_TYPE.light
        ? light
        : dark;

    document.documentElement.style.setProperty(`--${property}`, color);
  };

  useEffect(() => {
    setPropertyColor(
      'primary',
      theme?.primary ?? defaultTheme.primary,
      theme?.darkPrimary ?? defaultTheme.darkPrimary
    );
    setPropertyColor(
      'text',
      theme?.text ?? defaultTheme.text,
      theme?.darkText ?? defaultTheme.darkText
    );
    setPropertyColor(
      'background',
      theme?.background ?? defaultTheme.background,
      theme?.darkBackground ?? defaultTheme.darkBackground
    );
    setPropertyColor(
      'app-background',
      theme?.appBackground ?? defaultTheme.appBackground,
      theme?.darkAppBackground ?? defaultTheme.darkAppBackground
    );
    setPropertyColor(
      'secondary',
      theme?.secondary ?? defaultTheme.secondary,
      theme?.darkSecondary ?? defaultTheme.darkSecondary
    );
    setPropertyColor(
      'secondary-soft',
      theme?.secondarySoft ?? defaultTheme.secondarySoft,
      theme?.darkSecondarySoft ?? defaultTheme.darkSecondarySoft
    );
    setPropertyColor(
      'secondary-light',
      theme?.secondaryLight ?? defaultTheme.secondaryLight,
      theme?.darkSecondaryLight ?? defaultTheme.darkSecondaryLight
    );
  }, [theme, themeType, undefined]);

  return <>{children}</>;
};

export default ThemeProvider;
